module.exports = __webpack_public_path__ + "media/video_02.ccaee4c8.mp4";